import { render, staticRenderFns } from "./FreeShiftEditorDialog.vue?vue&type=template&id=a992d264&scoped=true&lang=pug&"
import script from "./FreeShiftEditorDialog.vue?vue&type=script&lang=ts&"
export * from "./FreeShiftEditorDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a992d264",
  null
  
)

export default component.exports